import "../createPassword/index.scss";

import React from "react";
import { connect } from "react-redux";
import _ from 'lodash';
import { showToast, getParameterByName, putData } from '../../globalFunction';

@connect((store) => {
    return {
        socket: store.socket.container,
    }
})
export default class ResetPassword extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            newPassword: '',
            confirmPassword: '',
            showNewPassword:false,
            showConfirmPassword:false,
            disabled: false,
        }
        _.map([
            'handleChange',
            'handleSubmit',
            'togglePassword'

        ], (fn) => {
            this[fn] = this[fn].bind(this);
        });
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }
    togglePassword(name) {
        this.setState({[name]:!this.state[name]})
    }
    handleSubmit(e) {
        e.preventDefault();

        showToast("success", "Updating password...", 360000);

        if (this.state.newPassword !== this.state.confirmPassword) {
            showToast("error", "Password and confirm password must be the same.");
            this.setState({ newPassword: '', confirmPassword: '', disabled: false });
        } else if (this.state.newPassword.length < 6) {
            showToast("error", "Passwords at least 6 characters.");
            this.setState({ newPassword: '', confirmPassword: '', disabled: false });
        } else {
            let url = window.location;
            let hash = getParameterByName('hash', url);
            putData(`/auth/forgotPassword`, { newPassword: this.state.newPassword, hash: hash }, (c) => {
                if (c.data) {
                    showToast('success', "Password successfully saved!")
                    setTimeout(function () {
                        window.location.replace('/');
                    }, 1000);
                } else {
                    showToast('error', 'Something went wrong. Please try again.')
                }
            })
        }
    }

    render() {
        const{showNewPassword, showConfirmPassword} = this.state;
           const isValid = this.state.newPassword && this.state.confirmPassword && (this.state.newPassword === this.state.confirmPassword)
        return (
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#f5f5f5',
                }}
            >
                <div id="login" style={{ width: '100%', maxWidth: 600 }}>
                    <div class="form-signin">
                        <div class="border-top"></div>   
                        <div class="logo logo-header">
                            <img src="/images/cloudcfo-logo-colored-icon-beside-text.png" class="img-responsive" style={{height: '27px'}}/>
                            <h1 class="">Reset your Password</h1>
                        </div>
                        <form class="reset-form usersForm pt20">
                            <div class="form-group tw-text-left">
                                <label class="m0">New Password</label>
                                <div class="passwordContainer">
                                    <input type={`${showNewPassword?'text':'password'}` }placeholder="Enter new password" value={this.state.newPassword} name="newPassword" onChange={this.handleChange} class="form-control bottom" />
                                    <a class="password-show" onClick={()=>{this.togglePassword('showNewPassword')}}>
                                        {showNewPassword? <i class="material-icons" style={{top: "37px" }}> visibility</i>: <i class="material-icons" style={{top: "37px" }}> visibility_off</i> } 
                                    </a>
                                    {   this.state.newPassword.length > 0 &&
                                        this.state.newPassword.length < 6 ?
                                        <div class="m0 errorMsg"><i class="material-icons-outlined mr5">info</i><span>Password should be at least 6 characters</span></div>
                                        :
                                        <div class="m0 errorMsg noError"><span>Password should be at least 6 characters</span></div>
                                    }
                                </div>
                            </div>
                            <div class="form-group mb20 tw-text-left">
                                <label>Confirm New Password</label>
                                <div class="passwordContainer">
                                    <input type={`${showConfirmPassword?'text':'password'}` } placeholder="Confirm password" value={this.state.confirmPassword} name="confirmPassword" onChange={this.handleChange} class="form-control bottom" />
                                    <a class="password-show mt5" onClick={()=>{this.togglePassword('showConfirmPassword')}}>
                                        {showConfirmPassword? <i class="material-icons" style={{top: "37px" }}> visibility</i>: <i class="material-icons" style={{top: "37px" }}> visibility_off</i> }
                                    </a>
                                    {!isValid && this.state.confirmPassword !== "" && <div class="m0 errorMsg"><i class="material-icons-outlined mr5">info</i><span>Passwords do not match!</span></div>}
                                </div>
                                {isValid && <i class="material-icons">check_circle_outline</i>}
                            </div>
                            {isValid && this.state.newPassword.length >= 6 && this.state.confirmPassword.length >= 6 ? 
                                <React.Fragment>
                                    <a class="btn mt40" onClick={this.handleSubmit}>Save</a>
                                </React.Fragment>: <React.Fragment>
                                    <a class="btn disabled mt40">Save</a>
                                </React.Fragment>
                            }
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}